import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 text-center">
      <div className="w-20 h-20 rounded-full bg-primary-100 flex items-center justify-center mb-6">
        <i className="ri-error-warning-line text-primary-500 text-4xl w-10 h-10 flex items-center justify-center" />
      </div>
      <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
        页面未找到
      </h1>
      <p className="text-foreground-500 mb-8 max-w-md text-sm md:text-base">
        抱歉，您访问的页面不存在。您可以返回首页浏览好看的韩国漫画全集，或使用免费下拉式阅读模式在线阅读韩漫。
      </p>
      <div className="flex flex-col sm:flex-row items-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-primary-500 text-white px-6 py-3 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-line text-sm w-4 h-4 flex items-center justify-center" />
          返回首页
        </Link>
        <Link
          to="/category/love"
          className="inline-flex items-center gap-2 bg-background-100 text-foreground-700 px-6 py-3 rounded-full text-sm font-medium hover:bg-background-200/80 transition-all cursor-pointer whitespace-nowrap"
        >
          <i className="ri-book-open-line text-sm w-4 h-4 flex items-center justify-center" />
          浏览漫画
        </Link>
      </div>
    </div>
  );
}